import type { FormSchema } from '../../../../../app/infrastructure/form';

/**
 * Contact form schema — single source of truth for ContactPanel fields.
 */
export const contactFormSchema: FormSchema = {
  name: 'contact',
  sections: [
    {
      id: 'contact',
      fields: [
        {
          name: 'first_name',
          type: 'text',
          labelKey: 'contact-panel.first_name',
          placeholderKey: 'contact-panel.first_name',
          validation: { required: true },
          layout: { xs: 12, md: 6 },
        },
        {
          name: 'last_name',
          type: 'text',
          labelKey: 'contact-panel.last_name',
          placeholderKey: 'contact-panel.last_name',
          validation: { required: true },
          layout: { xs: 12, md: 6 },
        },
        {
          name: 'email',
          type: 'email',
          labelKey: 'contact-panel.email',
          placeholderKey: 'contact-panel.email',
          validation: { required: true },
          layout: { xs: 12, md: 6 },
        },
        {
          name: 'phone',
          type: 'phone',
          labelKey: 'contact-panel.phone',
          placeholderKey: 'contact-panel.phone',
          validation: { required: true },
          layout: { xs: 12, md: 6 },
        },
        {
          name: 'message',
          type: 'textarea',
          labelKey: 'contact-panel.message',
          placeholderKey: 'contact-panel.message',
          validation: { required: true },
          rows: 3,
          layout: { xs: 12 },
        },
      ],
    },
  ],
};
